import TfwKey from './TfwKey';

export default TfwKey;